'use strict';

require('backbone');
const AnnouncementRepository = require('feedback/domain/repository/announcement');
const AnnouncementCollection = require('feedback/domain/collection/announcement');

class CollectionFactory {
    constructor() {
        this._collection = new AnnouncementCollection([], {
            sortKey: 'publishedAt',
            repository: AnnouncementRepository
        });
    }

    getCollection() {
        return this._collection;
    }
}

module.exports = new CollectionFactory();



// WEBPACK FOOTER //
// ./feedback/domain/factory/announcement/collection.js